import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { ApiResponse } from '@app/_models';
import { AlertService } from '@app/_services';
import { FeatureService } from '@app/_components/property/feature';

@Injectable({
	providedIn: 'root'
})

@Injectable()
export class AvailableDevelopmentFeaturesResolver  {

	constructor(
		private router: Router,
		private featureService: FeatureService,
		private alertService: AlertService) { }

	resolve(activatedRouteSnapshot: ActivatedRouteSnapshot, routerStateSnapshot: RouterStateSnapshot): Observable<ApiResponse>
	{
		return this.featureService.findAvailablePropertyFeaturesByDevelopmentId(+activatedRouteSnapshot.paramMap.get('developmentId'));
	}
}
